<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="txt-head black--text d-flex justify-space-between">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span> OOI / ตัวชี้วัดความสำเร็จ
        </div>

        <v-btn icon :class="{ 'rotate180': OOIExpanded }" @click="OOIExpanded = !OOIExpanded">
          <Iconify
              icon="material-symbols:keyboard-arrow-down"
              color="var(--theme-color-seven)"
          ></Iconify>
        </v-btn>
      </div>

      <div class="card-part expandable pt-0" :class="{ 'expanded mt-3': OOIExpanded }">
        <div class="d-flex align-end black--text font-type-bold mb-5 gap-24">
          <div style="width: 50%" class="txt-head black--text">
            1. ตัวชี้วัดความสำเร็จ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>
          <div style="width: 25%; text-indent: 25%">RSP</div>
          <div style="width: 25%; text-indent: 25%">สป.อว.</div>
        </div>

        <div class="d-flex flex-column gap-16">
          <div
              v-for="(item, i) in masterData.plan_master"
              :key="i"
          >
            <div class="font-type-bold black--text mb-3">
              {{ item.plan_name_th }}
            </div>

            <div class="d-flex flex-column gap-8">
              <!--   OOI   -->
              <div
                  v-for="(kpiItem, ind) in item.kpi_masters"
                  :key="ind"
              >
                <div v-if="!kpiItem.prefix_flag" class="d-flex flex-column gap-24">
                  <div class="flex d-flex align-center justify-space-between">
                    <div class="pb-6 black--text d-flex gap-12 pl-10" style="width: 50%">
                      <div class="font-type-bold flex" style="min-width: 80px; max-width: 80px">
                        {{ exceptShowKPINo.includes(kpiItem.no) ? '' : 'ตัวชี้วัดที่ '+kpiItem.no }}
                      </div>
                      <div class="flex">{{ kpiItem.name }}</div>
                    </div>
                    <div v-if="kpiItem.no !== '22'" class="d-flex gap-12" style="width: 25%">
                      <TextField
                          theme="3"
                          :readonly="!exceptReadonly.includes(kpiItem.no) || isOIC"
                          text-align="center"
                          input-type="decimal"
                          isFormat
                          :value="kpi[kpiItem.id] ? kpi[kpiItem.id].kpi_value : ''"
                          @onChange="setKpiField(kpiItem.id, $event, 'kpi_value')"
                      ></TextField>
                      <div class="pt-2" style="min-width: 130px">{{ kpiItem.unit }}</div>
                    </div>
                    <div v-if="kpiItem.no !== '22'" class="d-flex gap-12" style="width: 25%">
                      <TextField
                          theme="3"
                          :readonly="!isOIC"
                          text-align="center"
                          input-type="decimal"
                          isFormat
                          :value="kpi[kpiItem.id] ? kpi[kpiItem.id].kpi_value_ops : ''"
                          @onChange="setKpiField(kpiItem.id, $event, 'kpi_value_ops')"
                      ></TextField>
                      <div class="pt-2" style="min-width: 130px">{{ kpiItem.unit }}</div>
                    </div>
                  </div>
                  <div v-if="kpiItem.no !== '22'" class="flex">
                    <TextArea
                        v-if="kpiItem.desc_flag"
                        theme="3"
                        height="150px"
                        :placeholder="kpiItem.desc_label"
                        :value="kpi[kpiItem.id] ? kpi[kpiItem.id].description : ''"
                        @onChange="setKpiField(kpiItem.id, $event, 'description')"
                    ></TextArea>
                  </div>
                  <div v-else class="d-flex gap-24">
                    <div class="pb-6 black--text d-flex gap-12 pl-10" style="width: 50%">
                      <div class="font-type-bold flex" style="min-width: 80px; max-width: 80px">
                      </div>
                      <div class="flex">มีการรายงานผลการใช้งบประมาณที่ได้รับการรับรองจาก
                        ผู้ตรวจบัญชี ตามพรบ.วีธีการงบประมาณ 2563</div>
                    </div>
                    <div class="d-flex gap-12" style="width: 25%">
                      <v-radio-group row style="width: 100%" v-model="kpi[kpiItem.id].kpi_value">
                        <v-radio label="มี" value="1"></v-radio>
                        <v-radio label="ไม่มี" value="0" class="pl-12"></v-radio>
                      </v-radio-group>
                    </div>
                  </div>
                </div>

                <div v-else class="font-type-bold black--text pl-10  mb-2">
                  {{ kpiItem.name }}
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </divcard>


    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            2. ผลลัพธ์และผลกระทบ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <TextArea
                  theme="3"
                  height="120"
                  :value="form.quantity"
                  @onChange="setFormField('quantity', $event)"
              ></TextArea>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <TextArea
                  theme="3"
                  height="120"
                  :value="form.quality"
                  @onChange="setFormField('quality', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>


    <divcard>
      <div class="txt-head black--text d-flex justify-space-between">
        <div>
          3. ภาคผนวก (โครงการ)
          <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
        </div>

        <Button
            theme="6"
            @onClick="addAnnexProject"
        >
          + เพิ่มโครงการ
        </Button>
      </div>

      <div class="card-part mt-5 pt-0">
        <div>
          <div
              v-for="(item, i) in annexProjects"
              :key="i"
              class="mb-3"
          >
            <div class="font-type-bold mb-1">โครงการที่ {{ i + 1 }}</div>
            <div class="d-flex">
                <AutoBox
                  theme="3"
                  :items="masterData.form_c"
                  :item-text="itemText"
                  item-value="id"
                  return-object
                  clearable
                  :value="item.form_c_id"
                  @onChange="chooseCForm(i, $event)"
                  @onClear="chooseCForm(i)"
                ></AutoBox>
                <v-btn medium icon @click="removeAnnexProjects(i)">
                  <Iconify
                      icon="material-symbols:delete"
                      color="var(--theme-color-seven)"
                      style="font-size: 30px"
                  ></Iconify>
                </v-btn>
            </div>
          </div>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import TextArea from "../../../components/input/TextArea"
import SwitchInset from "../../../components/input/SwitchInset"
import OOILineField from "../../../components/OOILineField"
import Button from "../../../components/input/Button"
import AutoBox from "../../../components/input/AutoBox"
import { eventBus } from "../../../plugins/global-funcs"
import { mapState } from "vuex"

export default {
  name: "BFormOOI",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    OOILineField,
    Button
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      form: {},
      kpi: {},
      OOIExpanded: true,
      expanded: false,
      OOIs: [
        {
          kpi_sub_value_rsp: '',
          kpi_sub_value_ops: ''
        }
      ],
      annexProjects: [],
      exceptShowKPINo: ['20.1', '20.2', '20.3', '20.4', ''],
      exceptReadonly: ['20', '20.1', '20.2', '20.3', '20.4', '21', '22', '']
    }
  },
  computed: {
    ...mapState({
      OOIForm: state => state.AForm.OOIForm,
      isOIC: state => state.Auth.User.user_type === 'สป.อว.'
    })
  },
  created () {
    if (this.isSameId && !this.masterData.form_b) this.form = this.OOIForm
    if (this.masterData.form_b) {
      this.setData()
    }
    eventBus.$on('bFormOOI', () => {
      eventBus.$emit('bFormOOISend', {
        ...this.form,
        kpi_values: Object.values(this.kpi),
        kpi_annex_projects: this.annexProjects
      })
    })

    eventBus.$on('bFormOOISetData', () => this.setData())
  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    setData(){
      this.annexProjects = this.masterData.form_b.kpi_annex_project
      this.form.quantity = this.masterData.form_b?.form_ab_general_info?.kpi_quantity
      this.form.quality = this.masterData.form_b?.form_ab_general_info?.kpi_quality
      if (this.masterData.plan_master) {
        for (const y of this.masterData.plan_master) {
          for (const x of y.kpi_masters) {
            this.kpi[x.id] = {}
            this.kpi[x.id].kpi_master_id = x.id
            if (x.kpi_values) {
              this.kpi[x.id].id = x.kpi_values.id
              if(x.id == 27)
                this.kpi[x.id].kpi_value = x.kpi_values?.kpi_value?.toString()
              else
                this.kpi[x.id].kpi_value = x.kpi_values.kpi_value
              this.kpi[x.id].kpi_value_ops = x.kpi_values.kpi_value_ops
              this.kpi[x.id].description = x.kpi_values.description
            }else{
              this.kpi[x.id].kpi_value = null
              this.kpi[x.id].kpi_value_ops = null
              this.kpi[x.id].description = null
            }
          }
        }
      }
    },
    addAnnexProject () {
      this.annexProjects.push({})
    },
    itemText (item) {
      return item.project_section_general_info?.project_name_th || item.project_section_general_info?.lab_name
    },
    removeAnnexProjects(index){
      this.annexProjects.splice(index, 1);
      this.$forceUpdate();
    },
    setKpiField (id, val, field) {
      // format {
      //   kpi_master_id: '',
      //   kpi_value: ''
      // }
      if (!this.kpi[id]) this.kpi[id] = {}
      this.kpi[id].kpi_master_id = id
      this.kpi[id][field] = val
      this.$forceUpdate()
    },
    chooseCForm (index, val = null) {
      if(val != null){
        this.annexProjects[index].form_c_id = val.id
      }else{
        // clear kpi value
        this.annexProjects[index].form_c_id = null
      }
      
      // set val to 0 and set obj
      for (const x of this.masterData.form_c[0].kpi_values) {
        if (!this.kpi[x.kpi_master_id]) {
            this.kpi[x.kpi_master_id] = {}
          }
        this.kpi[x.kpi_master_id].kpi_value = 0
      }

      for (const x of this.annexProjects) {
        
        if(!x.form_c_id){
          continue
        }
        // find formC data form annexProjects 
        var form_c_data = this.masterData.form_c.find(item => item.id === x.form_c_id )

        // sum kpi value
        for (const x of form_c_data.kpi_values) {
          this.kpi[x.kpi_master_id].kpi_master_id = x.kpi_master_id
          this.kpi[x.kpi_master_id].kpi_value += x.kpi_value
        }
      }

      
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>